import './index.css';
import logo from '../../assets/img/logo.png';
import { Link } from 'react-router-dom';
import { useAuth } from '../../utils/context/AuthContext';
import OfflineNotice from '../../components/utility/OfflineNotice';
import { menuConfig } from '../../configs/menuConfig';
import { useCommandPalette } from '../../utils/hooks/useCommandPalette';
import CommandPalette from '../../components/command-palette/CommandPalette';
import { IconUser } from '@tabler/icons-react';
import { GlobalLoader } from '../../components/loader/GlobalLoader';
import { Toaster } from 'sonner';

const DefaultLayout = ({ children }) => {
    const { user, logout } = useAuth();
    const { open, setOpen } = useCommandPalette();

    const hasAccess = (roles) => !roles || roles.some((r) => user.roles?.includes(r));

    return (
        <>
            <OfflineNotice />

            <div className="layout-fluid">
                <div className="page">
                    <header className="navbar navbar-expand-md navbar-custom d-print-none">
                        <div className="container-xl">
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
                                <Link to="/">
                                    <img src={logo} alt="Logo" width="70" height="auto" />
                                </Link>
                            </div>

                            <div className="navbar-nav flex-row order-md-last">
                                <div className="nav-item dropdown">
                                    <a href="#" className="nav-link d-flex lh-1 p-0 px-2" data-bs-toggle="dropdown" aria-label="Open user menu" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
                                        <span className="avatar avatar-sm">
                                            <IconUser size={24} />
                                        </span>
                                        <div className="d-none d-xl-block ps-2">
                                            <div className="head-right-text">{user?.nom ?? 'Utilisateur'}</div>
                                            <div className="mt-1 small text-secondary head-right-text">{user?.roles?.length ? user.roles.join(', ') : 'Rôle'}</div>
                                        </div>
                                    </a>

                                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                        <a href="/profil" className="dropdown-item">
                                            Mon compte
                                        </a>
                                        <div className="dropdown-divider"></div>
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                logout();
                                            }}
                                        >
                                            Déconnexion
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    <header className="navbar-expand-md">
                        <div className="collapse navbar-collapse" id="navbar-menu">
                            <div className="navbar">
                                <div className="container-xl">
                                    <div className="row flex-fill align-items-center">
                                        <div className="col">
                                            <ul className="navbar-nav">
                                                {menuConfig
                                                    .filter((item) => hasAccess(item.roles))
                                                    .map((item) =>
                                                        item.children ? (
                                                            <li key={item.label} className="nav-item dropdown">
                                                                <a className="nav-link dropdown-toggle" href="#navbar-base" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
                                                                    {item.icon}&nbsp;
                                                                    <span className="nav-link-title">{item.label}</span>
                                                                </a>
                                                                <div className="dropdown-menu">
                                                                    <div className="dropdown-menu-columns">
                                                                        <div className="dropdown-menu-column">
                                                                            {item.children
                                                                                .filter((c) => hasAccess(c.roles))
                                                                                .map((child) => (
                                                                                    <a key={child.href} className="dropdown-item" href={child.href}>
                                                                                        {child.label}
                                                                                    </a>
                                                                                ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ) : (
                                                            <li key={item.label} className="nav-item">
                                                                <Link className="nav-link" to={item.to}>
                                                                    {item.icon}&nbsp;
                                                                    <span className="nav-link-title">{item.label}</span>
                                                                </Link>
                                                            </li>
                                                        ),
                                                    )}

                                                <li key="command-palette" className="nav-item mx-1">
                                                    <button className="btn" onClick={() => setOpen(true)} title="Recherche rapide (Ctrl+K)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <circle cx="11" cy="11" r="8" />
                                                            <path d="m21 21-4.35-4.35" />
                                                        </svg>
                                                        <span className="ms-2 d-none d-md-inline text-muted" style={{ fontSize: '0.8rem' }}>
                                                            Ctrl+K
                                                        </span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div className="page-wrapper">
                        <main>{children}</main>
                    </div>
                </div>
            </div>

            <CommandPalette open={open} setOpen={setOpen} menuConfig={menuConfig} user={user} />
            <GlobalLoader />
            <Toaster position="top-right" richColors closeButton expand />
        </>
    );
};

export default DefaultLayout;
